import type { MissionSubmission } from '../types/mission'

export interface SubmissionStatusTagDefinition {
  slug: MissionSubmission['status']
  name: string
  variant: 'light-red'
}

// Só 'refused' tem tag hoje — approved/pending/awaiting_correction não
// entram em escopo desta feature. getSubmissionStatusTag retorna null
// pros demais, e o componente que o consome não renderiza nada.
export const SUBMISSION_STATUS_TAGS = [
  { slug: 'refused', name: 'Recusada', variant: 'light-red' }
] as const satisfies SubmissionStatusTagDefinition[]

export function getSubmissionStatusTag(
  status: MissionSubmission['status'] | null | undefined
) {
  return SUBMISSION_STATUS_TAGS.find(s => s.slug === status) ?? null
}
